import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-gif-large.tsx
/**
* icon.24.gif.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTYuNTczIDhhMiAyIDAgMCAxIDEuNzg4IDEuMTA1bC4wODYuMTcxYS41LjUgMCAwIDEtLjg5NC40NDhsLS4wODUtLjE3MUExIDEgMCAwIDAgNi41NzMgOUg1YTEgMSAwIDAgMC0xIDF2NGExIDEgMCAwIDAgMSAxaDEuNWExIDEgMCAwIDAgMS0xdi0xLjVINmEuNS41IDAgMCAxIDAtMWgyYS41LjUgMCAwIDEgLjUuNXYyYTIgMiAwIDAgMS0yIDJINWEyIDIgMCAwIDEtMi0ydi00YTIgMiAwIDAgMSAyLTJ6TTEzLjUgOGEuNS41IDAgMCAxIDAgMWgtMXY2aDFhLjUuNSAwIDAgMSAwIDFoLTNhLjUuNSAwIDAgMSAwLTFoMVY5aC0xYS41LjUgMCAwIDEgMC0xem03IDBhLjUuNSAwIDAgMSAwIDFoLTR2Mi41SDE5YS41LjUgMCAwIDEgMCAxaC0yLjV2M2EuNS41IDAgMCAxLTEgMHYtN0EuNS41IDAgMCAxIDE2IDh6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=24953-59518
*/
const Icon24GifLarge = memo(function Icon24GifLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M6.573 8a2 2 0 0 1 1.788 1.105l.086.171a.5.5 0 0 1-.894.448l-.085-.171A1 1 0 0 0 6.573 9H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1.5a1 1 0 0 0 1-1v-1.5H6a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zM13.5 8a.5.5 0 0 1 0 1h-1v6h1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1h1V9h-1a.5.5 0 0 1 0-1zm7 0a.5.5 0 0 1 0 1h-4v2.5H19a.5.5 0 0 1 0 1h-2.5v3a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 16 8z"
		})
	});
});
//#endregion
export { Icon24GifLarge };

//# sourceMappingURL=icon-24-gif-large.js.map